import api from '../api.js';
import db from '../../versa/db.js';
import crud from '../../versa/crud.js';
import router from '../../versa/router.js';
import { notify, ask } from '../../versa/msgbox.js';
import view from '../views/delivery-locations.js';
import form from '../forms/delivery-locations.js';
import * as types from '../types.js';

const delivery_locations = function()
{
	let delivery_locations_crud = crud.create({
		addFilter(params) {
			crud.addFilter.call(this, params);
			if (this.filter && JSON.stringify(this.filter).includes('is_disabled'))
				params.append('include_disabled', '1');
		},
		async loadBaseData()
		{
			api.call(api.list_companies, this.queryAll()).then((data) => db.set('companies', data).catch(error => notify(error)));
		},
		async queryData(query)
		{
			return await api.call(api.list_delivery_locations, query);
		},
		async loadRecord(id)
		{
			return await api.call(api.select_delivery_location, ...JSON.parse(id));
		},
		async setDisabled(disabled) {
			const ids = await this.getSelectedIds(['company_id', 'id']);
			if (!ids.length)
				return notify('Selecione ao menos um local de entrega.', 'Locais de entrega');
			const action = disabled ? 'Inativar' : 'Ativar';
			ask(`Confirma ${action} ${ids.length} local(is)?`, action, async (answer) => {
				if (answer !== 'Y')
					return;
				for (const [company_id, id] of ids) {
					const resp = await api.call(api.patch_delivery_location, company_id, id, { is_disabled: !!disabled });
					if (resp == null) {
						notify('Falha ao atualizar o local de entrega.', 'Locais de entrega');
						return;
					}
				}
				this.loadPage();
			});
		},
		async saveRecord(data, old_data)
		{
			const record = {
				name: data.name,
				is_disabled: data.is_disabled == '1',
			};
			if (old_data)
				return await api.call(api.update_delivery_location, data.company_id, data.id, record);
			return await api.call(api.insert_delivery_location, data.company_id, record);
		},
	});

	const fieldspecs = [
		{ index: 1, field: 'company_id', label: 'Empresa', types: [types.datalist()], placeholder: '', title: 'Empresa', store: 'companies', labels: ['nick'] },
		{ index: 2, field: 'id', label: 'Local', types: [types.number(0, 2)], placeholder: '0', title: 'Identificador do local' },
		{ index: 3, field: 'name', label: 'Nome', types: [], placeholder: '', title: 'Nome que aparece no pedido, na etiqueta e no romaneio' },
		{ index: 4, field: 'is_disabled', label: 'Inativo', types: [types.opt_bool(), types.datalist()], placeholder: '', title: 'Local inativo não entra na lista do pedido' },
	];

	const operations = [
		{ hash: '#delivery-location-disable', label: 'Inativar' },
		{ hash: '#delivery-location-enable', label: 'Ativar' },
	];

	router.set('#delivery-location-disable', delivery_locations_crud.setDisabled.bind(delivery_locations_crud, true));
	router.set('#delivery-location-enable', delivery_locations_crud.setDisabled.bind(delivery_locations_crud, false));

	delivery_locations_crud.run(
		'delivery_locations',
		'Locais de entrega',
		document.getElementById('workarea'),
		view,
		form,
		fieldspecs,
		operations,
		[]
	);
};

export default delivery_locations;
